import { Math as CesiumMath, Viewer } from "cesium";
import { TileModel } from "src/class/tileModel";
import { getMessage } from "../../language";
import '../../styles/Dialog/formLabelPoint.css';
import { DialogGeneral } from "../../utils/Dialog/dialog";
import { createUUID, findChildren, hasAnyValidInput } from "../../utils/utils";


export class FormMoveModel {
    viewer: Viewer;
    containerId: string;
    private _treeView: any;

    private _tileModel: TileModel[] | undefined = undefined
    private dialog: DialogGeneral | undefined;

    IdGenneral = createUUID(); // Tạo ID ngẫu nhiên khi khởi tạo
    constructor(containerId: string, viewer: any, treeTileModel: TileModel[], tileModel: TileModel[]) {
        this.containerId = containerId;  // Gán giá trị containerId    
        this.viewer = viewer;  // Gán giá trị viewer
        this._tileModel = tileModel; // Gán giá trị tileModel
        this._treeView = treeTileModel; // Gán giá trị treeTileModel
        if (tileModel && tileModel[0]?.inputObjs) {
            this._inputLongitudeValue = tileModel[0].inputObjs.longitude ?? 0;
            this._inputlatitudeValue = tileModel[0].inputObjs.latitude ?? 0;
            this._inputHeightValue = tileModel[0].inputObjs.height ?? 0;
            this._inputZValue = tileModel[0].inputObjs.z ?? 0;
            this._inputMaximumScreenValue = tileModel[0].inputObjs.maximumScreen ?? 16;
            this._inputSizePointCloud = tileModel[0].inputObjs.sizePointCloud ?? 2;
        }


        if (this._inputLongitudeValue || this._inputlatitudeValue || this._inputHeightValue) {
            this._checkBoxCart = true
            this._checkBoxCoord = false

        } else {
            this._checkBoxCoord = true
            this._checkBoxCart = false


        }

        this.createModalMoveTile()
        this.showHideModalLabelPoint(true)
    }



    createModalMoveTile = () => {
        this.dialog = new DialogGeneral(
            this.containerId,
            this.handleCloseModal
        );
        this.dialog.innerHeader = getMessage('model-title-option-tileset');
        this.dialog.isModal = true
        this.dialog.minimizeDialog = false;
        this.dialog.zIndex = 1000
        this.dialog.topModal = "50%"
        this.dialog.leftModal = "50%"
        this.dialog.widthModal = '250px'
        this.dialog.heightModal = '500px'
        // this.dialog.minHeightModal = 440
        // this.dialog.minWidthModal = 250

        // this.dialog.heightModal = '160px'
        // this.dialog.heightModal = '225px'

        this.dialog.minHeightModal = 160
        this.dialog.firstLoad = false
        // Lấy chuỗi HTML của tree view và gán cho innerBody
        this.dialog.innerBody = this.renderBodyModal();
        this.dialog.innerFooter = this.renderFooter();
        this.dialog.createDialog();
    }


    showHideModalLabelPoint = (show: boolean) => {

        this.dialog?.showModal(show)
    }
    private handleCloseModal = (status: boolean) => {
        if (!status) {


        }
    }
    private containerBody: HTMLDivElement | undefined
    private renderBodyModal = (): HTMLElement => {
        if (this.containerBody) {
            this.clearContainer()
        } else {
            this.containerBody = document.createElement('div')
            this.containerBody.className = 'container-form-label-point'

        }

        this.createForm()
        return this.containerBody
    }



    private clearContainer = () => {
        if (this.containerBody) {
            while (this.containerBody.firstChild) {
                this.containerBody.removeChild(this.containerBody.firstChild);
            }
        }
    };

    // Removed redundant getter/setter for inputSizePointCloud

    //#region createForm
    private _inputSizePointCloud: number = 2
    private _inputLongitudeValue: number = 0
    private _inputlatitudeValue: number = 0
    private _inputHeightValue: number = 0
    private _inputZValue: number = 0
    private _inputMaximumScreenValue: number = 0

    private _checkBoxCoord: boolean = true
    private _checkBoxCart: boolean = false

    private createForm = () => {
        this.containerBody!.innerHTML = `
            <label>Maximum space error screen:</label>
            <input 
            class="input-form-label dpu-input-text" 
            id="input-maximumScreen-${this.IdGenneral}" 
            type="number" 
            min="1"
            value="${this._inputMaximumScreenValue}"             
            />

            <label>${getMessage('size-point-cloud')}:</label>
            <input 
            class="input-form-label dpu-input-text" 
            id="input-size-${this.IdGenneral}" 
            type="number" 
            min="1"
            max="10"
            value="${this._inputSizePointCloud}"             
            />

            <div class="checkbox-container">
            <input 
                type="checkbox" 
                class="dpu-input-check-box" 
                id="check-coordinates-${this.IdGenneral}" 
                ${this._checkBoxCoord ? "checked" : ""} 

            />
            <label for="check-coordinates-${this.IdGenneral}">${getMessage('check-coordinate-system')}</label>
            </div>

            <label>Z (m):</label>
            <input 
            class="input-form-label dpu-input-text ${this._checkBoxCoord ? "" : "disable"}" 
            id="input-z-${this.IdGenneral}" 
            type="number" 
            value="${this._inputZValue}" 
            
            />

            <div class="checkbox-container">
            <input 
                type="checkbox" 
                class="dpu-input-check-box" 
                id="check-cartesian-${this.IdGenneral}" 
                ${this._checkBoxCart ? "checked" : ""} 

            />
            <label for="check-cartesian-${this.IdGenneral}">${getMessage('check-coordinate-geographic')}</label>
            </div>

            <label>${getMessage('footer-longitude')}:</label>
            <input 
            class="input-form-label dpu-input-text ${this._checkBoxCart ? "" : "disable"}" 
            id="input-longitude-${this.IdGenneral}" 
            type="number" 
            value="${this._inputLongitudeValue}" 
           
            ${this._checkBoxCart ? "" : "disabled"}
            />

            <label>${getMessage('footer-latitude')}:</label>
            <input 
            class="input-form-label dpu-input-text ${this._checkBoxCart ? "" : "disable"}" 
            id="input-latitude-${this.IdGenneral}" 
            type="number" 
            value="${this._inputlatitudeValue}" 
            
            ${this._checkBoxCart ? "" : "disabled"}

            />

            <label>${getMessage('height')} (m):</label>
            <input 
            class="input-form-label dpu-input-text ${this._checkBoxCart ? "" : "disable"}" 
            id="input-height-${this.IdGenneral}" 
            type="number" 
            value="${this._inputHeightValue}" 
            
            ${this._checkBoxCart ? "" : "disabled"}

            />
        `;

        // this.containerBody!.innerHTML = `
        //     <label>Maximum space error screen:</label>
        //     <input class="input-form-label dpu-input-text"   id="input-maximumScreen-${this.IdGenneral}" type="number" value = "${this._inputMaximumScreenValue}" placeholder="Nhập maximum screen"/>


        //     <label>Z (m):</label>
        //     <input 
        //     class="input-form-label dpu-input-text" 
        //     id="input-z-${this.IdGenneral}" 
        //     type="number" 
        //     value="${this._inputZValue}" 
        //     placeholder="Nhập Z"            
        //     />

        //   `
        this.handleTrackInput()

    }

    private containerFooter: HTMLDivElement | undefined
    private renderFooter = (): HTMLElement => {
        this.containerFooter = document.createElement('div')
        this.containerFooter.className = 'container-footer-lable-point'
        this.containerFooter.innerHTML = `         
        <button id="btn-create-${this.containerId}" class="btn-ok-modal">OK</button>       
     `
        // Gán sự kiện riêng cho các nút không thuộc nhóm
        const btnOk = this.containerFooter.querySelector(`#btn-create-${this.containerId}`);
        if (btnOk) {
            btnOk.addEventListener('click', () => this.btnOk());
        }

        return this.containerFooter
    }


    //#region handleTrackInput
    private longitudeInput: HTMLInputElement | undefined;
    private latitudeInput: HTMLInputElement | undefined;
    private heightInput: HTMLInputElement | undefined;
    private zInput: HTMLInputElement | undefined;
    private maximumScreenInput: HTMLInputElement | undefined;
    private sizePointCloudInput: HTMLInputElement | undefined;

    private _inputCheckBoxCoord: HTMLInputElement | undefined;
    private _inputCheckBoxCart: HTMLInputElement | undefined;

    //#region handleTrackInput
    /**
     * Initialize input elements and attach event listeners
     */
    private handleTrackInput = () => {
        this.initializeInputs();
        this.attachInputListeners();
    };

    //#region initializeInputs
    private initializeInputs = () => {
        this.longitudeInput = this.getInputElement(`#input-longitude-${this.IdGenneral}`);
        this.latitudeInput = this.getInputElement(`#input-latitude-${this.IdGenneral}`);
        this.heightInput = this.getInputElement(`#input-height-${this.IdGenneral}`);
        this.zInput = this.getInputElement(`#input-z-${this.IdGenneral}`);
        this.maximumScreenInput = this.getInputElement(`#input-maximumScreen-${this.IdGenneral}`);
        this.sizePointCloudInput = this.getInputElement(`#input-size-${this.IdGenneral}`);
        this._inputCheckBoxCoord = this.getInputElement(`#check-coordinates-${this.IdGenneral}`);
        this._inputCheckBoxCart = this.getInputElement(`#check-cartesian-${this.IdGenneral}`);
    };

    //#region getInputElement
    private getInputElement = (selector: string): HTMLInputElement | undefined => {
        return this.containerBody?.querySelector(selector) as HTMLInputElement;
    };

    //#region attachInputListeners
    private attachInputListeners = () => {
        this._inputCheckBoxCoord?.addEventListener("change", () => this.toggleCheckBox(true));
        this._inputCheckBoxCart?.addEventListener("change", () => this.toggleCheckBox(false));

        this.attachInputListener(this.longitudeInput, (value) => (this._inputLongitudeValue = value));
        this.attachInputListener(this.latitudeInput, (value) => (this._inputlatitudeValue = value));
        this.attachInputListener(this.heightInput, (value) => (this._inputHeightValue = value));
        this.attachInputListener(this.zInput, (value) => (this._inputZValue = value));
        this.attachInputListener(this.maximumScreenInput, (value) => {
            this._inputMaximumScreenValue = value;
            this.validateInputMaximumScreen(this.maximumScreenInput!);
        });
        this.attachInputListener(this.sizePointCloudInput, (value) => {
            this._inputSizePointCloud = value;
            this.validateSizePointCloud(this.sizePointCloudInput!);
        });
    };

    //#region attachInputListener
    private attachInputListener = (input: HTMLInputElement | undefined, callback: (value: number) => void) => {
        input?.addEventListener("input", () => {
            const value = Number(input.value);
            callback(value);
        });
    };

    //#region validateInputMaximumScreen
    private validateInputMaximumScreen = (input: HTMLInputElement) => {
        let value = Number(input.value);
        if (!Number.isInteger(value) || isNaN(value) || value < 1 || value > 16) {
            value = 1;
        }
        input.value = value.toString();
    };

    private validateSizePointCloud = (input: HTMLInputElement) => {
        let value = Number(input.value);
        if (isNaN(value) || value < 1) {
            value = 1;
        }
        if (isNaN(value) || value > 10) {
            value = 10
        }
        input.value = value.toString();
    };

    //#region toggleCheckBox
    private toggleCheckBox = (isCoord: boolean) => {
        this._checkBoxCoord = isCoord;
        this._checkBoxCart = !isCoord;

        this.updateCheckBoxState(this._inputCheckBoxCoord, isCoord);
        this.updateCheckBoxState(this._inputCheckBoxCart, !isCoord);

        this.toggleInputState(this.longitudeInput, !isCoord);
        this.toggleInputState(this.latitudeInput, !isCoord);
        this.toggleInputState(this.heightInput, !isCoord);
        this.toggleInputState(this.zInput, isCoord);
    };

    //#region updateCheckBoxState
    private updateCheckBoxState = (checkbox: HTMLInputElement | undefined, isChecked: boolean) => {
        if (checkbox) {
            checkbox.checked = isChecked;
        }
    };

    //#region toggleInputState
    private toggleInputState = (input: HTMLInputElement | undefined, isEnabled: boolean) => {
        if (input) {
            input.disabled = !isEnabled;
            input.classList.toggle("disable", !isEnabled);
        }
    };



    //#region btnOk()
    private btnOk = () => {
        // Lấy giá trị của các input
        this._inputMaximumScreenValue = Number(this.maximumScreenInput!.value);
        this._inputSizePointCloud = Number(this.sizePointCloudInput!.value);


        this._tileModel?.forEach(tile => {
            this._handleUpdateTileModel(tile);
        });

        // console.log(this._treeView);
        this.viewer.scene.requestRender();
        this.dialog?.destroyDialog();
    }

    private _handleUpdateTileModel = (tile: TileModel) => {

        if (tile.inputObjs) {
            // tile.inputObjs.maximumScreen = this._inputMaximumScreenValue === 16 ? undefined : this._inputMaximumScreenValue;
            if (this._checkBoxCoord) {
                tile.inputObjs = {
                    ...tile.inputObjs,
                    longitude: undefined,
                    latitude: undefined,
                    height: undefined,
                    z: this._inputZValue === 0 ? undefined : this._inputZValue,
                }

                // tile.setTransformZ(this._inputZValue)
            } else {
                tile.inputObjs = {
                    ...tile.inputObjs,
                    longitude: this._inputLongitudeValue === 0 ? undefined : this._inputLongitudeValue,
                    latitude: this._inputlatitudeValue === 0 ? undefined : this._inputlatitudeValue,
                    height: this._inputHeightValue === 0 ? undefined : this._inputHeightValue,
                    z: undefined,
                }


            }

            if (tile.isFolder) {
                const children = findChildren(this._treeView, tile.id)
                // const tempChildren = [...children]
                tile.setMaximumScreenSpaceError(this._inputMaximumScreenValue);
                tile.setMaximumAttenuation(this._inputSizePointCloud)
                if (children.length > 0) {
                    if (hasAnyValidInput(tile.inputObjs)) {
                        // Tính toán delta (độ thay đổi) từ vị trí cũ sang vị trí mới
                        const deltaLongitude = tile.inputObjs!.longitude! - CesiumMath.toDegrees(tile.originalCartgraphic?.longitude);
                        const deltaLatitude = tile.inputObjs!.latitude! - CesiumMath.toDegrees(tile.originalCartgraphic?.latitude);

                        children.forEach((child: TileModel) => {
                            // const itemFromTree = this._treeView.find((x:TileModel) => x.id === child.id);
                            if (child && child.originalCartgraphic) {
                                // Tạo bản sao mới cho inputObjs để tránh sửa đổi trực tiếp đối tượng gốc
                                const newInputObjs = { ...child.inputObjs! }; // Sao chép inputObjs
                                const newLongitude = CesiumMath.toDegrees(child.originalCartgraphic?.longitude) + deltaLongitude;
                                const newLatitude = CesiumMath.toDegrees(child.originalCartgraphic?.latitude) + deltaLatitude;

                                // Cập nhật giá trị mới vào bản sao của inputObjs
                                newInputObjs.longitude = isNaN(newLongitude) ? undefined : newLongitude;
                                newInputObjs.latitude = isNaN(newLatitude) ? undefined : newLatitude;
                                newInputObjs.height = this._inputHeightValue === 0 ? undefined : this._inputHeightValue;

                                // Gán lại giá trị mới cho inputObjs
                                child.inputObjs = newInputObjs;
                                child.sceneManager.setPositionModel(child.tileset, child.inputObjs)



                            }
                            // console.log("this._inputMaximumScreenValue",);
                            child.setMaximumScreenSpaceError(this._inputMaximumScreenValue);
                            child.setMaximumAttenuation(this._inputSizePointCloud)

                        });
                    } else {
                        children.forEach((child: TileModel) => {
                            child.setMaximumScreenSpaceError(this._inputMaximumScreenValue);
                            child.setMaximumAttenuation(this._inputSizePointCloud)

                        });
                    }
                }
            } else {

                if (this._checkBoxCoord) {
                    tile.setTransformZ(this._inputZValue)

                } else {
                    tile.setModelMatrix({
                        longitude: this._inputLongitudeValue,
                        latitude: this._inputlatitudeValue,
                        height: this._inputHeightValue
                    })
                }
                tile.setMaximumScreenSpaceError(this._inputMaximumScreenValue);
                tile.setMaximumAttenuation(this._inputSizePointCloud)
            }

        }
    }


}